import { render, staticRenderFns } from "./PopuEdit.vue?vue&type=template&id=01527060&scoped=true&"
import script from "./PopuEdit.vue?vue&type=script&lang=js&"
export * from "./PopuEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01527060",
  null
  
)

export default component.exports